<div class="company-locations">
  <ng-container *hasPermission="{ permissions: createPerms }">
    <div class="add-location-container">
      <button
        mat-stroked-button
        type="button"
        color="primary"
        (click)="openLocationForm(null)"
      >
        <mat-icon>add_circle</mat-icon>
        {{ 'add' | i18nextCap }}
      </button>
    </div>
  </ng-container>

  @if (locations$ | async; as locations) {
    @for (location of locations; track location.id) {
      <mat-card class="action-item" [attr.data-testid]="'location-' + $index">
        <div class="action-item-left">
          <mat-icon>location_on</mat-icon>
          <div class="details">
            <span class="title">{{ location.name }}</span>
            <div class="subtitle">
              <span class="date-time">{{
                location.createdAt
                  | momentTimezoneToAngularTimezone: 'DD/MM/YYYY'
              }}</span>
              <span class="date-time">
                -
                {{
                  location.createdAt | momentTimezoneToAngularTimezone: 'HH:mm'
                }}</span
              >
            </div>
          </div>
        </div>
        <div class="action-item-right">
          <div [matTooltip]="'EDIT_LOCATION_TOOLTIP' | i18nextCap">
            <button
              mat-icon-button
              type="button"
              class="color-grey-600"
              (click)="openLocationForm(location)"
            >
              <mat-icon>open_in_new</mat-icon>
            </button>
          </div>
        </div>
      </mat-card>
    }
  }
</div>
